import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 115 72" {...props}><g fill="#fff" fillOpacity=".1" clipPath="url(#card-background_53_g__card-background_37_g__clip0_23441_146814)"><circle cx="-52.5" cy="109.5" r="139.5" /><circle cx="-62.5" cy="78.5" r="170.5" /></g></svg>;